export default [
  {
    path: '/admin/gen/list',
    name: 'genList',
    component: () => import('@/views/admin/gen/list.vue'),
    meta: { title: '导出列表', requireAuth: true, tabbar: 'genList' }
  }
]
